import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/ParasutSync";

export const PARASUT_SYNC_PREFIX_URL = PREFIX_URL;

// GET istekleri
export const GetRegions = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Regions`, options);

export const GetCustomers = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Customers`, options);

export const GetEmployees = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Employees`, options);

export const GetProducts = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Products`, options);

export const GetProductCategories = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ProductCategories`, options);

export const GetAccounts = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Accounts/:parasutAccountId`, options);

// POST istekleri - Transfer işlemleri
export const TransferCustomers = (options) =>
  GENERATE_URL(`${PREFIX_URL}/TransferCustomers/:parasutAccountId`, options);

export const TransferEmployees = (options) =>
  GENERATE_URL(`${PREFIX_URL}/TransferEmployees/:parasutAccountId`, options);

export const TransferProducts = (options) =>
  GENERATE_URL(`${PREFIX_URL}/TransferProducts/:parasutAccountId`, options);

export const TransferProductCategories = (options) =>
  GENERATE_URL(
    `${PREFIX_URL}/TransferProductCategories/:parasutAccountId`,
    options
  );

export const TransferRegions = (options) =>
  GENERATE_URL(`${PREFIX_URL}/TransferRegions/:parasutAccountId`, options);

export default {
  // GET metodları
  GetRegions,
  GetCustomers,
  GetEmployees,
  GetProducts,
  GetProductCategories,
  GetAccounts,

  // POST metodları
  TransferCustomers,
  TransferEmployees,
  TransferProducts,
  TransferProductCategories,
  TransferRegions,
};
